import { PDFDocument, rgb } from "pdf-lib";

import { baseUrl } from "../../api";
import {
  hexToRgb,
  generateQR,
  createPdfBlobUrl,
  embedImageFromUrl,
} from "./pdfUtils";

/**
 * Asset IDs for poster PDF
 */
const ASSETS = {
  TEXT_IMAGE: "b1f4f075-a83e-4762-821f-d370c5042587",
  COW_IMAGE: "3c68d832-1bf3-4dc8-bbbf-c2b39b774e54",
  CB_LOGO: "0f39ed71-df1a-4501-9ae1-252c89001baf",
};

/**
 * Generate cuts by colour poster PDF
 */
export const generateCutsByColourPDF = async (retailer) => {
  const qrCodeBytes = await generateQR(retailer?.store_url);
  const pdfDoc = await PDFDocument.create();
  const page = pdfDoc.addPage([769, 585]);
  const { width, height } = page.getSize();

  // Draw retailer background color
  page.drawRectangle({
    x: 0,
    y: 0,
    color: hexToRgb(retailer?.brand_color),
    height,
    width,
  });

  // Logo
  if (retailer?.logo) {
    try {
      const logoUrl = `${process.env.REACT_APP_API_URL}/assets/${retailer.logo}`;
      const embeddedLogo = await embedImageFromUrl(pdfDoc, logoUrl);

      if (embeddedLogo) {
        page.drawImage(embeddedLogo, {
          x: width / 2 - 114,
          y: height - 110,
          width: 228,
          height: 84,
        });
      }
    } catch (error) {
      console.error("Error embedding logo:", error);
    }
  }

  // Draw text image
  const textUrl = `${baseUrl}/assets/${ASSETS.TEXT_IMAGE}`;
  const textImageBytes = await fetch(textUrl).then((res) => res.arrayBuffer());
  const textImage = await pdfDoc.embedPng(textImageBytes);
  page.drawImage(textImage, {
    x: width / 2 - 150,
    y: height - 180,
    width: 300,
    height: 65,
  });

  // Draw cow image
  const cowUrl = `${baseUrl}/assets/${ASSETS.COW_IMAGE}`;
  const cowImageBytes = await fetch(cowUrl).then((res) => res.arrayBuffer());
  const cowImage = await pdfDoc.embedPng(cowImageBytes);
  page.drawImage(cowImage, {
    x: width / 2 - 310,
    y: height - 520,
    width: 620,
    height: 360,
  });

  // Draw QR code
  const qrCodeImage = await pdfDoc.embedPng(qrCodeBytes);
  page.drawImage(qrCodeImage, {
    x: width / 2 - 80,
    y: height - 540,
    width: 100,
    height: 100,
  });

  // Draw Canada Beef logo
  const cbLogoUrl = `${baseUrl}/assets/${ASSETS.CB_LOGO}`;
  const cbLogoImageBytes = await fetch(cbLogoUrl).then((res) =>
    res.arrayBuffer()
  );
  const cbLogoImage = await pdfDoc.embedPng(cbLogoImageBytes);
  page.drawImage(cbLogoImage, {
    x: width / 2 + 220,
    y: height - 580,
    width: 146,
    height: 156,
  });

  // Draw Canada Beef description text
  page.drawText(
    "For more information, recipes and cooking know how visit canadabeef.ca",
    {
      x: width / 2 + 20,
      y: height - 565,
      size: 10,
      color: rgb(1, 1, 1),
    }
  );

  return await createPdfBlobUrl(pdfDoc);
};
